import Vue from 'vue'
import Vuex from 'vuex'
import constants from './common/constants'
import { dbglog } from './common/utils.js'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    token: '',  // 認証トークン
    // クライアント情報
    clientInfo: {
      clientIp: '',       // クライアントIPアドレス
      clientType: '',     // クライアント種別
      //platform: '',     // 動作プラットフォーム Web, Touch ..?
    },
    // ユーザ管理
    userInfo: {
      mailAddress: '',    // ユーザのメールアドレス
      authority: 0,       // ユーザ権限
      appMode: 0,
      userName: '',
    },
    // to be obsoleted
    mailAddress: '',    // ユーザのメールアドレス
    authority: 0,       // ユーザ権限
    clientType: '',     // クライアント種別
    platform: 'Web',  // 動作プラットフォーム Web, Touch ..?
    // 動作モード
    mode: 0,  // 閲覧対象 1:建築確認 2:昇降機 3:定期報告 4:指定道路 5:開発 6:宅造 7:狭あい道路
    menuFlag: 0xff, // 0x01:建築, 0x02:昇降機, 0x04:定期報告, 0x08:指定道路, 0x10:開発, 0x20:宅造, 0x40:狭あい
    searchMode: 0, // 区選択時 0:地名地番検索 1:プロット地図検索
    currentPage: 0, // 0:Login 1:Menu 2:Ward 3:Town 4:Address 5:Map 6:List 7:Browse
    includeOldTowns: true,  // 住所検索で廃町を表示するか
    listId: 1,  // List種別（0:番号検索結果 1:住所検索結果 2:物件検索結果）
    debug: 0,   // デバッグモード
    kyoaiPrintDesc: true, // 狭あい道路実測図の追加文言を印刷する
    douroShubetsuVisible: true, // 狭あい道路マップに道路種別図レイヤを表示する
    seibiSokushinVisible: true, // 狭あい道路マップに整備促進路線レイヤを表示する」
    multiPrintLimit: 5, // 概要書を一度に印刷できる上限件数
    controlAcceptPage: false, // IP, IDにより同意画面遷移を制御するか
    controlPrintButton: false,  // IP, IDにより印刷ボタンの表示を制御するか
    controlRightButton: false, // 右クリック禁止用制御フラグ
    browseCountLimit: 50, // 1日の閲覧可能数
    manualBtnVisible: true, // マニュアル表示ボタンを表示するか
    manualOnlyNewUser: false, // new_userフラグが立っているユーザのみマニュアルボタン表示
    manualFileName: "Web閲覧システム操作マニュアル.pdf",

    // 表示メッセージ
    caption: '建築計画概要書等閲覧システム',  // ヘッダに表示するタイトル
    titleMessage: '', // ヘッダに表示する追加メッセージ
    message: '',  // フッタに表示するメッセージ
    // API読込み結果データ保持
    chibans: [],      // 取得した地番一覧
    summaries: [],    // 検索結果の概要書一覧
    gaiyoList: [],    // 概要書一覧
    attrList: [],     // 詳細検索結果一覧
    examList: [],     // 審査処分経過一覧
    daichoSearchSelect: [0,1,2,3,4,5,6,7,8,9],       // 2023/12/25 検索
    daichoSearch: {},       // 2023/12/25 検索
    daicho: [],       // 2023/12/25 検索結果の概要書一覧
    seldaicho: null,       // 2023/12/25 検索結果の概要書一覧
    seldaichoIndex: 0,       // 2023/12/25 検索結果の概要書一覧
    daichoImage: [],  // 2024/01/14 
    seldaichoImageIndex: 0,       //  2024/01/14
    seldaichoImageMode: 0,       //  2024/01/14
    kosakuData: null,
    gaiyoData: {      // 閲覧用概要書詳細データ
      bikO_NAIYO:'', timeI_TIBAN:'', snS_BLD_SU:0, dlvrer:'',
      nushi:[], dairi:null, sekkei:[], iken:[], seko:[] 
    },
    kisaiData: null,  // 記載証明書データ
    kamiData: null,   // 紙台帳データ用の新しいstate
    // 閲覧対象ID保持
    ukeNo: '',      // 対象受付番号
    gaiyoId: '',    // 概要書 DAICHO_ID
    kojiId: '',     // 概要書 KOJI_ID
    // 閲覧対象フラグ
    gaiyoEnabled: true,
    // 住所検索パラメータ保持
    ward: null,     // 区オブジェクト
    // to be obsoleted
    wardCode: 0,    // 区コード
    wardName: '',   // 区名
    townCode: '',   // 町コード
    townName: '',   // 町名
    townTab: '',    // 選択されている町一覧のタブ
    oyaban: 0,      // 地番親番
    edaban: 0,      // 地番枝番
    // 番号検索パラメータ保持
    searchEra: 1,
    searchNendo: null,
    searchYear: 0,
    searchBango: 0,
    searchTargetType: 0,  // 建築物 0:建築 1:工作
    searchTargetKaihatsuType: 0,  // 開発・造成・土石の堆積 0:開発, 1:旧宅造, 2:宅規, 3:農規, 4:森規, 5:土規 2025/03/16追加
    shiteiNo: null,
    // Map関連
    centerx: -18033.043,  // Map中心X座標
    centery: -61003.644,  // Map中心Y座標
    plotRadius: 5,  // 確認プロットのサイズ
    features: [],   // Mapで選択されているフィーチャ
    sheets: [],     // Map中心のプロット図郭ID
    selectedNo: '', // 選択されている概要書番号
    selectedId: 0,  // 選択されているフィーチャのID
    // 印刷関連
    printing: false,
    singlePrint: false,
    printList: [],  // 印刷対象一覧
    printPageCount: 0,  // 印刷対象ページ数
    gaiyoPages: [], // プレビュー中概要書のページ情報リスト
    gaiyoPageNo: 0, // プレビュー中概要書の表示ページ
    // プロット地図関連
    nendoName: '',  // プロット地図年度（簿冊）名
    indexId: 0, // 索引図ID
    plotPage: 0, // プロット地図ページ番号
    // URL
    apiOrigin: '',    // API URL
    mapOrigin: '',    // 地図タイルURL
    imgOrigin: '',    // 三面画像URL
    imgOldOrigin: '', // 紙台帳画像URL
    imgExt: '',       // 画像ファイルの拡張子
    teihoImgOrigin: '', // 定期報告概要書U画像RL
    kaihatsuImgOrigin: '',  // 開発登録簿画像URL
    kaihatsuChoshoOrigin: '', // 開発登録簿調書画像URL
    shiteiImgOrigin: '',  // 位置指定道路図画像URL
    kyoaiImgOrigin: '', // 狭あい道路実測図画像URL
    kenkakuPlotImgOrigin: '', // 建築確認プロット地図画像URL
    kenkakuPlotIndexOrigin: '', // 建築確認プロット地図索引図画像URL
    kaihatsuPlotImgOrigin: '',  // 開発・造成・土石の堆積（旧 開発・宅造）プロット地図画像URL
    kaihatsuPlotIndexOrigin: '',  // 開発・造成・土石の堆積（旧 開発・宅造）プロット地図索引図画像URL
    acceptPageUrl: '',  // 同意ページURL
    officialSealUrl: '',  // 公印画像URL
    // 詳細検索関連
    searchAttrCond: null, // 詳細検索条件保持用変数
    listAttrData: null, // 詳細検索結果リスト選択行記憶変数
    listExamDispData: null, // 審査処分経過リスト選択行記憶変数
    // 画像閲覧情報保持
    imageInfo: { id:0, src:'', scale:1, x:0, y:0 },
    frameInfo: { visible:false, x:0, y:0 },

    // 2024/12/12 職員操作編集可能
    kakushinButtonThresholdDate: '',
    mapAttribution: '',
    menuNoticeHtml: '',
    menuNoticeDialogOpen: false,

    // 職員操作編集可能
    editMode: false,

    // 発行者（市長変更対応）
    hakkosha: '',

  },
  mutations: {
    // API、画像ファイルの基準URLを設定する
    setOrigins(state, origins) {
      state.apiOrigin = origins.apiOrigin;
      state.daichoOrigin = origins.daichoOrigin;
      state.mapOrigin = origins.mapOrigin;
      state.imgOrigin = origins.imgOrigin;
      state.imgOldOrigin = origins.imgOldOrigin;
      state.teihoImgOrigin = origins.teihoImgOrigin;
      state.kaihatsuImgOrigin = origins.kaihatsuImgOrigin;
      state.kaihatsuChoshoOrigin = origins.kaihatsuChoshoOrigin;
      state.shiteiImgOrigin = origins.shiteiImgOrigin;
      state.kyoaiImgOrigin = origins.kyoaiImgOrigin;
      state.kenkakuPlotImgOrigin = origins.kenkakuPlotImgOrigin;
      state.kenkakuPlotIndexOrigin = origins.kenkakuPlotIndexOrigin;
      state.kaihatsuPlotImgOrigin = origins.kaihatsuPlotImgOrigin;
      state.kaihatsuPlotIndexOrigin = origins.kaihatsuPlotIndexOrigin;
      state.acceptPageUrl = origins.acceptPageUrl;
      state.officialSealUrl = origins.officialSealUrl;
      //options
      state.debug = origins.debug;
      state.imgExt = origins.imgExt;
      state.plotRadius = origins.plotRadius;
      state.kyoaiPrintDesc = origins.kyoaiPrintDesc;
      state.douroShubetsuVisible = origins.douroShubetsuVisible;
      state.seibiSokushinVisible = origins.seibiSokushinVisible;
      state.multiPrintLimit = origins.multiPrintLimit;
      state.controlAcceptPage = origins.controlAcceptPage;
      state.controlPrintButton = origins.controlPrintButton;
      state.controlRightButton = origins.controlRightButton;
      state.browseCountLimit = origins.browseCountLimit ?? 50;
      state.manualBtnVisible = origins.manualBtnVisible ?? true;
      state.manualOnlyNewUser = origins.manualOnlyNewUser ?? false;
      state.manualFileName = origins.manualFileName ?? "Web閲覧システム操作マニュアル.pdf";
    },
    setUserConfig(state, val) {
      state.kakushinButtonThresholdDate = val.kakushinButtonThresholdDate;
      state.mapAttribution = val.mapAttribution ;
      state.hakkosha = val.hakkosha;
    },
    setMenuNoticeHtml(state, val) {
      state.menuNoticeHtml = val ?? '';
    },
    setMenuNoticeDialogOpen(state, val) {
      state.menuNoticeDialogOpen = !!val;
    },
    setManualBtnVisible(state, val) {
      state.manualBtnVisible = val;
    },
    setSinglePrint(state, val) {
      state.singlePrint = val;
    },
    setPrinting(state, val) {
      state.printing = val;
    },
    setClientType(state, val) {
      state.clientType = val;
    },
    setAuthority(state, val) {
      state.authority = val;
    },
    setMailAddress(state, val) {
      state.mailAddress = val;
    },
    setToken(state, val) {
      state.token = val;
    },
    setDebug(state, val) {
      state.debug = val;
    },
    setClientInfo(state, val) {
      state.clientInfo = val;
    },
    setUserInfo(state, val) {
      state.userInfo = val;
    },
    // 閲覧対象の設定
    setMode(state, mode) {
      state.mode = mode;
      state.caption = constants.browseTargets[mode].caption;
      /*
      if (state.clientType == 'admin') {
        state.caption += '（管理者）';
      }
      */
      //state.caption += ':' + state.clientType;
    },
    setMenuFlag(state, val) {
      state.menuFlag = val;
    },
    setSearchMode(state, mode) {
      state.searchMode = mode;
    },
    setCurrentPage(state, pageNo) {
      state.currentPage = pageNo;
    },
    // ヘッダに表示するタイトル
    setCaption(state, val) {
      state.caption = val;
    },
    setTitleMessage(state, val) {
      state.titleMessage = val;
    },
    // フッタに表示するメッセージ
    setMessage(state, val) {
      state.message = val;
    },
    // マップの中心座標
    setCenter(state, coord) {
      if (coord.x != null && coord.x != 0 && coord.y != null && coord.y != 0) {
        state.centerx = coord.x;
        state.centery = coord.y;
      }
    },
    setFeatures(state, val) {
      state.features = val;
    },
    setSheets(state, val) {
      state.sheets = val;
    },
    setSelectedNo(state, val) {
      state.selectedNo = val;
    },
    setSelectedId(state, val) {
      state.selectedId = val;
    },
    setWard(state, ward) {
      state.ward = ward;
      if (ward) {
        state.wardCode = ward.code;
        state.wardName = ward.name;
      }
      else {
        state.wardCode = 0;
        state.wardName = '';
      }
    },
    setWardCode(state, code) {
      state.wardCode = code;
      for (const ward of constants.Wards) {
        if (ward.code == code) {
          state.ward = ward;
          state.wardName = ward.name;
          break;
        }
      }
      dbglog('store.setWard(' + code + ')');
      dbglog('state: ' + state.wardCode + ' ' + state.wardName);
    },
    setTown(state, town) {
      state.townCode = town.code;
      state.townName = town.name;
    },
    setTownCode(state, code) {
      state.townCode = code;
    },
    setTownName(state, name) {
      state.townName = name;
    },
    setTownTab(state, val) {
      state.townTab = val;
    },
    setChibanOya(state, val) {
      state.oyaban = (val == '') ? 0 : val;
    },
    setChibanEda(state, val) {
      state.edaban = (val == '') ? 0 : val;
    },
    setChibans(state, val) {
      state.chibans = val;
    },
    setSummaries(state, val) {
      state.summaries = val;
      state.gaiyoId = null;
    },
    
    setDaichoSearchSelect(state, val) {
      state.daichoSearchSelect = val;
    },
    setDaichoSearch(state, val) {
      state.daichoSearch = val;
    },
    setDaicho(state, val) {
      state.daicho = val;
    },
    setSeldaicho(state, val) {
      state.seldaicho = val;
    },
    setSeldaichoindex(state, val) {
      state.seldaichoIndex = val;
    },
    setDaichoimage(state, val) {
      state.daichoImage = val;
    },
    setDaichoimageindex(state, val) {
      state.seldaichoImageIndex = val;
    },
    setDaichoimageMode(state, val) {
      state.seldaichoImageMode = val;
    },
    setUkeNo(state, val) {
      state.ukeNo = val;
    },
    setUkeDay(state, val) {
      state.ukeDay = val;
    },
    setGaiyoId(state, val) {
      state.gaiyoId = val;
    },
    setKojiId(state, val) {
      state.kojiId = val;
    },
    setGaiyoEnabled(state, val) {
      state.gaiyoEnabled = val;
    },
    setGaiyoList(state, val) {
      state.gaiyoList = val;
    },
    setAttrList(state, val) {
      state.attrList = val;
    },
    setExamList(state, val) {
      state.examList = val;
    },
    setListId(state, val) {
      state.listId = val;
    },
    setGaiyoData(state, val) {
      if (val === null) {
        val = {
          bikO_NAIYO:'', timeI_TIBAN:'', snS_BLD_SU:0, dlvrer:'',
          nushi:[], dairi:null, sekkei:[], iken:[], seko:[] 
        };
      }
      dbglog('store.setGaiyoData:' + val);
      state.gaiyoData = val;
    },
    setKosakuData(state, val) {
      state.kosakuData = val;
    },
    setKisaiData(state, val) {
      state.kisaiData = val;
    },
    setGaiyoPageNo(state, val) {
      state.gaiyoPageNo = val;
    },
    setGaiyoPages(state, val) {
      state.gaiyoPages = val;
    },
    clearGaiyoPages(state) {
      state.gaiyoPages.length = 0;
    },
    // 番号検索入力値
    setSearchEra(state, val) {
      state.searchEra = val;
    },
    setSearchNendo(state, val) {
      state.searchNendo = val;
    },
    setSearchYear(state, val) {
      state.searchYear = val;
    },
    setSearchBango(state, val) {
      state.searchBango = val;
    },
    setSearchTargetType(state, val) {
      state.searchTargetType = val;
    },
    setSearchTargetKaihatsuType(state, val) {
      state.searchTargetKaihatsuType = val;
    },
    setShiteiNo(state, val) {
      state.shiteiNo = val;
    },
    // 概要書印刷予約関連
    clearPrintList(state) {
      state.printList.length = 0;
    },
    addPrintList(state, val) {
      for (let i = 0; i < state.printList.length; i++) {
        state.printList[i].active = false;
      }
      //const found = state.printList.some(el => el.ukeNo == val.ukeNo);
      const found = state.printList.some(el => el.daichoId == val.daichoId);
      if (!found) {
        state.printList.push(val);
      }
      state.printPageCount = 0;
      for (let i = 0; i < state.printList.length; i++) {
        state.printPageCount += state.printList[i].pageCount;
      }
    },
    removePrintList(state, val) {
      if (val && val.active) {
        val.active = false;
      }
      state.printList = state.printList.filter(d => d !== val);
      state.printPageCount = 0;
      for (let i = 0; i < state.printList.length; i++) {
        state.printPageCount += state.printList[i].pageCount;
      }
    },
    clearePrintList(state) {
      state.printList.length = 0;
      state.printPageCount = 0;
    },
    // プロット地図関連
    setNendoName(state, val) {
      state.nendoName = val;
    },
    setIndexId(state, val) {
      state.indexId = val;
    },
    setPlotPage(state, val) {
      state.plotPage = val;
    },
    setListAttrData(state, val){
      state.listAttrData = val;
    },
    setListExamDispData(state, val){
      state.listExamDispData = val;
    },
    setSearchAttrCond(state,val){
      state.searchAttrCond = val;
    },
    setImageInfo(state, val) {
      state.imageInfo = val;
    },
    setFrameInfo(state, val) {
      state.frameInfo = val;
    },
    setDouroShubetsuVisible(state, val) {
      state.douroShubetsuVisible = val;
    },
    setKamiData(state, val) {
      state.kamiData = val;
    },
  },
  actions: {

  },
  getters: {

  },
})
